module.exports = __webpack_public_path__ + "media/brusselhelpt.1bbdaa70.mp4";